module.exports = __webpack_public_path__ + "img/A58A0029.debd5e65.jpg";